module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "quote"
    }
  }, [_vm._v("For every man the world is as fresh as it was at the first day,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And as full of untold novelties for him who has the eyes to see them.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Thomas Henry Huxley, English biologist,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("1825–1895")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bfe038c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4quote.vue
// module id = 72
// module chunks = 0